import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

interface PagesData {
    phone: string | null;
    email: string | null;
    tg_bot: string | null;
    address: string | null;
    companyName: string;
    companyDescription: string;
    workingDaysWeekdays: string | null;
    workingDaysWeekends: string | null;
    socialLinks: { vk: string | null; tg: string | null; youtube: string | null; instagram: string | null; tiktok: string | null };
}

interface PagesContextType {
    data: PagesData | null;
    loading: boolean;
    error: string | null;
}

const PagesContext = createContext<PagesContextType>({
    data: null,
    loading: true,
    error: null,
});

export const usePages = () => useContext(PagesContext);

export const PagesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [data, setData] = useState<PagesData | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchPages = async () => {
            try {
                const BASE_URL = import.meta.env.VITE_API_BASE_URL;
                const response = await axios.get(`${BASE_URL}/api/v1/pages`);
                const pages = response.data?.pages || [];
                const aboutPage = pages.find((p: any) => p.slug === 'about');

                if (!aboutPage) throw new Error('Страница about не найдена');

                setData({
                    phone: aboutPage.content.phone || null,
                    email: aboutPage.content.email || null,
                    tg_bot: aboutPage.content.tg_bot || null,
                    address: aboutPage.content.address || aboutPage.content.adress || null,
                    companyName: aboutPage.content.name_company || 'CTB ДИЗАЙН',
                    companyDescription: aboutPage.meta_title || 'Премиальные услуги по строительству и ремонту коммерческой недвижимости.',
                    workingDaysWeekdays: aboutPage.content.working_days_weekdays || null,
                    workingDaysWeekends: aboutPage.content.working_days_weekends || null,
                    socialLinks: {
                        vk: aboutPage.content.vk || null,
                        tg: aboutPage.content.tg || null,
                        youtube: aboutPage.content.youtube || null,
                        instagram: aboutPage.content.instagram || aboutPage.content.insta || null,
                        tiktok: aboutPage.content.tiktok || null,
                    },
                });
            } catch (err: any) {
                console.error('Ошибка загрузки PagesContext:', err);
                setError(err.message || 'Ошибка загрузки данных');
            } finally {
                setLoading(false);
            }
        };

        fetchPages();
    }, []);

    return (
        <PagesContext.Provider value={{ data, loading, error }}>
            {children}
        </PagesContext.Provider>
    );
};
